import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
let isToken=false
export function request(config) {
    const instance = new axios.create({
        baseURL: '',
        timeout: 30000
    });

    // 请求拦截器
    instance.interceptors.request.use(config => {
        //拦截后需要将拦截下来的请求数据返回发送
        return config;
    }, error => {
        console.log(error)
    })

    // 相应拦截器
    instance.interceptors.response.use(res => {
        // 拦截后需要将拦截下来处理成的结果返回
        if (res.status !== 200) {
            Message({
                message: '服务器内部错误',
                type: 'warning'
            })
        } else {
            if(res.data.errorCode == '3001'){
                let msg = res.data.msg;
                if(!isToken){
                    isToken=true;
                    store.dispatch("UserLogout").then((res) => {
                        if (res.success === "1") {
                            Message({
                                message: msg,
                                type: 'error'
                            })
                            setTimeout(()=>{
                                router.push({
                                    path: '/pcViews/login',
                                })
                                isToken=false
                            },2000)
                        }
                    });
                }

            }else{
                return res.data
            }
        }
    }, error => {
        console.log(error)
    })

    return instance(config)
}
